import { useEffect, useRef, useState } from "react";
import "./index.css";
/**
 * @callback onClickHandler
 * @param {PointerEvent} e
 * @param {Object} context
 */
/**
 * @param {Object} props
 * @param {onClickHandler} props.onClickHandler - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isSelected
 * @param {string} props.listBgColor - background color for list eg 'primary-list' note not in var
 * @param {React.ReactNode} props.children
 * @param {string} props.hoverHeight - pass hover part height for proper animation
 * @param {Object} props.context - This object is passed as the second parameter to `onClickHandler`
 *
 * @returns {JSX.Element}
 */
const ListContainer = ({
  isDisabled,
  isSelected,
  onClickHandler,
  children,
  context,
  listBgColor,
  filterRef,
  hoverHeight = 0,
}) => {
  let listBody, listHover;
  const cardRef = useRef(null);
  const [openUpward, setOpenUpward] = useState(false);

  if (!Array.isArray(children)) {
    listBody = children;
    listHover = null;
  } else if (children.length > 2) {
    throw new Error(
      "list container cannot have any more than a <list-body> and a <list-hover>",
    );
  } else {
    [listBody, listHover] = children;
  }

  const handleMouseEnter = () => {
    cardRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "end",
    });
    const container = filterRef?.current;
    const card = cardRef.current;

    if (!container || !card) return;

    const cardRect = card.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const willOverflowBottom =
      cardRect.bottom + Number(hoverHeight) > containerRect.bottom &&
      cardRect.top > containerRect.top + Number(hoverHeight);

    setOpenUpward(willOverflowBottom);
  };

  return (
    <div
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      className="standard-list-parent-container"
    >
      <div
        style={{
          top: openUpward ? undefined : 0,
          bottom: openUpward ? 0 : undefined,
        }}
        onClick={(e) => {
          if (!isDisabled) onClickHandler(e, context);
        }}
        className={` ${isDisabled ? "" : isSelected ? "global-hover-black" : "global-hover-white"}  ${isDisabled ? "cursor-not-allowed  standard-list-container-disabled pointer-events-none" : "cursor-pointer standard-list-container"} ${isSelected ? "bg-positive-bg" : listBgColor ? `bg-${listBgColor}` : "bg-primary-card"}`}
      >
        <div
          className={`${listHover ? "standard-list-div" : "standard-list-div-inactive"}`}
        >
          {listBody}
        </div>
        <div className={listHover ? `standard-list-hover-div` : ""}>
          {listHover}
        </div>
      </div>
    </div>
  );
};

export default ListContainer;
